import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconArrow2Right = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.937 13.91'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M23.847,6.568 C23.948,6.811 23.948,7.085 23.847,7.329 C23.797,7.450 23.725,7.559 23.633,7.650 C23.633,7.650 23.633,7.651 23.633,7.651 L17.655,13.615 C17.460,13.809 17.206,13.906 16.951,13.906 C16.696,13.906 16.441,13.809 16.246,13.615 C15.857,13.227 15.857,12.597 16.246,12.209 L20.523,7.942 L1.011,7.942 C0.460,7.942 0.014,7.497 0.014,6.948 C0.014,6.399 0.460,5.955 1.011,5.955 L20.523,5.955 L16.246,1.688 C15.857,1.300 15.857,0.670 16.246,0.282 C16.635,-0.106 17.266,-0.106 17.655,0.282 L23.633,6.246 C23.633,6.246 23.633,6.246 23.633,6.247 C23.725,6.338 23.797,6.447 23.847,6.568 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconArrow2Right.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
